import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../stores/settings-stores';
import appApi from '../../../../../api/app-api';

export const deletePaymentTypeOperation = async (
  paymentTypeId: number,
  setDeletePaymentTypeId: (id: number | null) => void,
) => {
  try {
    setDeletePaymentTypeId(paymentTypeId);

    const res = await appApi.deletePaymentServiceType(paymentTypeId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      await globalSettingsStores.fetchSetting();
    }
    setDeletePaymentTypeId(null);
  } catch (e) {
    setDeletePaymentTypeId(null);
    console.error(
      `deletePaymentTypeOperation is failed with the paymentTypeId: ${paymentTypeId}, and the error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
